// Style!
import './App.css';
import './light.css';
import './dark.css';

// Components
import Header from './components/Header/Header';
import AreaMap from './components/AreaMap/AreaMap';
import Info from './components/Info/Info';
import ZoomedMap from './components/ZoomedMap/ZoomedMap';
import Plot from './components/Plot/Plot';
import Footer from './components/Footer/Footer';
import LandingPage from './components/LandingPage/LandingPage';

// Global Hooks
import useLocationIDs from './hooks/useLocationIDs';
import useRiverID from './hooks/useRiverID';
import useStateSchema from './hooks/useStateSchema';
import useThemeToggle from './hooks/useThemeToggle';
import useOperationalStates from './hooks/useOperationalStates';
import useForecastPubTime from './hooks/useForecastPubTime';

function App() {
  const operationalStates = useOperationalStates();
  const { locationIDs, handleLocationIDsChange } = useLocationIDs();
  const { riverID, handleRiverIDChange } = useRiverID();
  const { stateSchema, handleStateSchemaChange } = useStateSchema({
    handleLocationIDsChange,
    handleRiverIDChange,
    operationalStates
  });
  const { minForecastPubTime, forecastPubTime, handleForecastPubTimeChange } =
    useForecastPubTime(operationalStates[stateSchema]);

  const { theme, handleThemeChange, appendThemeCSS } = useThemeToggle();

  if (stateSchema === '') {
    return (
      <div className={appendThemeCSS('app')}>
        <div className='header'>
          <Header
            themeMode={theme}
            stateSchema={stateSchema}
            handleStateSchemaChange={handleStateSchemaChange}
            operationalStates={operationalStates}
          />
        </div>
        <div>
          <LandingPage operationalStates={operationalStates} />
        </div>
        <div className='footer'>
          <Footer />
        </div>
        <button className='theme-btn' onClick={handleThemeChange}>
          {theme === 'light' ? (
            <span>&#9728;&#65039;</span>
          ) : (
            <span>&#127769;</span>
          )}
        </button>
      </div>
    );
  }

  return (
    <div className={appendThemeCSS('app grid')}>
      <div className='header'>
        <Header
          themeMode={theme}
          stateSchema={stateSchema}
          handleStateSchemaChange={handleStateSchemaChange}
          operationalStates={operationalStates}
          minForecastPubTime={minForecastPubTime}
          forecastPubTime={forecastPubTime}
          handleForecastPubTimeChange={handleForecastPubTimeChange}
        />
      </div>
      <div className='areamap'>
        <AreaMap
          stateSchema={stateSchema}
          handleLocationIDsChange={handleLocationIDsChange}
          operationalStates={operationalStates}
        />
      </div>
      <div className='zoommap'>
        <ZoomedMap
          stateSchema={stateSchema}
          locationIDs={locationIDs}
          handleLocationIDsChange={handleLocationIDsChange}
          riverID={riverID}
          handleRiverIDChange={handleRiverIDChange}
          operationalStates={operationalStates}
        />
      </div>
      <div className='info'>
        <Info stateSchema={stateSchema} locationIDs={locationIDs} />
      </div>
      <div className='plot'>
        <Plot
          stateSchema={stateSchema}
          locationIDs={locationIDs}
          theme={theme}
          forecastPubTime={forecastPubTime}
        />
      </div>
      <div className='footer'>
        <Footer />
      </div>
      <button className='theme-btn' onClick={handleThemeChange}>
        {theme === 'light' ? (
          <span>&#9728;&#65039;</span>
        ) : (
          <span>&#127769;</span>
        )}
      </button>
    </div>
  );
}

export default App;
